(function () {
	'use strict';
	angular.module('app.dashboard')
		.service('weeklyLogItemService', weeklyLogItemService);

	weeklyLogItemService.$inject = ['$rootScope', '$http', '$q', 'URLS', 'leanFilterService'];
	function weeklyLogItemService($rootScope, $http, $q, URLS, leanFilterService) {
		var data = [];
		var currency = '';
		var extraParams = {};
		var dataLoaded = false;
		var logDataUrl = URLS.prefix + '{0}' + '/WeeklyLogItem';
		var varDataUrl = URLS.prefix + '{0}' + '/FactoryControlVariables/';
		var timeoutCanceler;
		var currentPromise;
		var loadingUrl = '';
		var purchasedItemFields = {};
		var manufacturedItemFields = {};
		var finishedGoodFields = {};
		var currentVarsPromise = null;
		var varData = {};

		return {
			loadData: loadData,
			loadVars: loadVars,
			getVarsObj: getVarsObj,
			getResultObj: getResultObj,
			clearData: clearData,
			addField: addField
		};

		function getVarsObj() {
			return varData;
		}

		function loadVars() {
			var url = buildVarUrl();
			if (currentVarsPromise === null) {
				if (timeoutCanceler == null) {
					timeoutCanceler = $q.defer();
				}
				currentVarsPromise = $http.get(URLS.host + url, {timeout: timeoutCanceler.promise})
					.then(loadVarsSuccess)
					.catch(loadVarsError);
			}
			return currentVarsPromise;

			function loadVarsSuccess(response) {
				if (response && response.data) {
					varData = response.data;
				} else {
					varData = {};
				}
			}

			function loadVarsError(error) {
				varData = {};
				return currentVarsPromise;
			}
		}

		function buildVarUrl() {
			var paramsObj = {
				settingNames:'PROCUREMENT_FINISHED_GOODS_PAST_WEEKS_OF_ORDERS,PROCUREMENT_FINISHED_GOODS_FUTURE_WEEKS_OF_ORDERS,PROCUREMENT_BUCKETS_IN_PERIOD'
			};
			return addQueryParam(varDataUrl,
				leanFilterService.getFactoryList(), paramsObj, false);
		}

		function loadData() {
			var url = buildUrl();
			if (loadingUrl !== url) {
				clearData();
				loadingUrl = url;
				timeoutCanceler = $q.defer();
				currentVarsPromise = null;
				currentPromise = $http.get(URLS.host + url, {timeout: timeoutCanceler.promise})
					.then(loadDataSuccess)
					.catch(loadDataError);
			}
			return currentPromise;
			
			function loadDataSuccess(response) {
				if (response && response.data) {
					data = response.data.data;
					currency = response.data.currency;
					extraParams = response.data.extraParams;
				}
				dataLoaded = true;
			}

			function loadDataError(error) {
				data.length = 0;
				dataLoaded = true;
				return currentPromise;
			}
		}

		function getResultObj() {
			return {
				data: _.cloneDeep(data),
				currency: currency,
				extraParams: extraParams
			};
		}

		function clearData(clearFields) {
			dataLoaded = false;
			data.length = 0;
			currency = '';
			loadingUrl = '';
			extraParams = {};
			if (currentPromise && timeoutCanceler) {
				timeoutCanceler.resolve();
			}
			if (clearFields) {
				purchasedItemFields.length = 0;
				manufacturedItemFields.length = 0;
			}
		}

		function addField(fields) {
			if (Array.isArray(fields)) {
				fields.forEach(addField);
				return;
			}
			if (fields.type === 'Purchased'){
				purchasedItemFields[fields.field] = true;
			} else if (fields.type === 'Manufactured') {
				manufacturedItemFields[fields.field] = true;
			} else if (fields.type === 'FinishedGood') {
				finishedGoodFields[fields.field] = true;
			}
		}

		function buildUrl() {
			var purchasedFieldNames = [];
			for (var key in purchasedItemFields) {
				if (purchasedItemFields[key]) {
					purchasedFieldNames.push(key);
				}
			}
			var manufacturedFieldNames = [];
			for (var key in manufacturedItemFields) {
				if (manufacturedItemFields[key]) {
					manufacturedFieldNames.push(key);
				}
			}
			var finishedGoodFieldNames = [];
			for (var key in finishedGoodFields) {
				if (finishedGoodFields[key]) {
					finishedGoodFieldNames.push(key);
				}
			}
			var paramsObj =  {
				'purchasedFields': purchasedFieldNames,
				'manufacturedFields': manufacturedFieldNames,
				'finishedGoodFields': finishedGoodFieldNames
			};
			var url = addQueryParam(logDataUrl,
				leanFilterService.getFactoryList(), paramsObj, false);
			return leanFilterService.addFilterQueryParams(url);
		}
	}
})();
